const CREATE_FARM_RESPONSE = {
  Farm: 'Farm',
  TokenError: 'TokenError',
};

export default CREATE_FARM_RESPONSE;
